import React from "react";

/*
The card shell every block on this page sits in, including the
loading -> error -> empty -> content ladder so no section re-implements it.

`skeleton` is only shown on a first load; a refetch (period change) keeps the
previous content on screen so the page doesn't flash.
*/
const TnCard = function (props) {
  const {
    title,
    subtitle,
    action,
    loading,
    hasLoadedOnce,
    error,
    onRetry,
    empty,
    emptyText,
    skeleton,
    className,
    bodyClassName,
    children,
  } = props;

  const showSkeleton = loading && !hasLoadedOnce;

  let body;
  if (showSkeleton) {
    body = skeleton || null;
  } else if (error) {
    body = (
      <div className="tn-alert" role="alert">
        <span className="tn-alert-text">{error}</span>
        {onRetry ? (
          <button type="button" className="tn-alert-retry" onClick={onRetry}>
            Retry
          </button>
        ) : null}
      </div>
    );
  } else if (empty) {
    body = <div className="tn-empty">{emptyText || "Nothing to show."}</div>;
  } else {
    body = children;
  }

  return (
    <section className={"tn-card" + (className ? " " + className : "")}>
      {title || action ? (
        <header className="tn-card-head">
          <div className="tn-card-headings">
            {title ? <h2 className="tn-card-title">{title}</h2> : null}
            {subtitle ? (
              <span className="tn-card-subtitle">{subtitle}</span>
            ) : null}
          </div>
          {action ? <div className="tn-card-action">{action}</div> : null}
        </header>
      ) : null}
      <div className={"tn-card-body" + (bodyClassName ? " " + bodyClassName : "")}>
        {body}
      </div>
      {/* A refetch over existing content: thin bar instead of a full skeleton. */}
      {loading && hasLoadedOnce ? <div className="tn-card-refreshing" /> : null}
    </section>
  );
};

export default TnCard;
